import React from 'react';
import { FaImage } from "react-icons/fa";
import { getImageUrl } from '../../../../Utils/localStorageUtils';
import useCustomNavigate from '../../../../hooks/useCustomNavigate';
import { useParams } from 'react-router-dom';

const PhotoGallery = ({ images }) => {
  const {goTo} = useCustomNavigate()
  const {propertyId} = useParams()
  // Dummy image data
  const images1 = [
    { src: 'https://img.staticmb.com/mbphoto/property/cropped_images/2024/Nov/10/Photo_h300_w450/75899025_1_Broom01_300_450.jpg', alt: 'Interior' },
    { src: 'https://img.staticmb.com/mbphoto/property/cropped_images/2024/Nov/10/Photo_h300_w450/75899025_3_asterPlan10UniqueSapphireJaipur_300_450.jpg', alt: 'Layout' },
    { src: 'https://img.staticmb.com/mbphoto/property/cropped_images/2024/Nov/10/Photo_h300_w450/75899025_2_BSapphirelocation_300_450.jpg', alt: 'Map' },
  ];


  return (
    <>
      <div className='ml-0 sm:ml-4 rounded-lg overflow-hidden cursor-pointer'
      onClick={()=>{goTo(`/propertydetail/${propertyId}/gallery`)}}
      >
        <div className="flex mb-2 h-[200px] overflow-hidden">
          <img
            src={getImageUrl(images?.[0]?.fileName) || "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Nov/10/Photo_h300_w450/75899025_1_Broom01_300_450.jpg"}
            alt="Main Property"
            className="shadow-lg w-full h-full"
            onError={(e) => { e.target.src = "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Nov/10/Photo_h300_w450/75899025_1_Broom01_300_450.jpg" }}
          />
        </div>
        <div className="flex justify-between gap-[12px] bg-white">
          {images?.slice(0, 3)?.map((image, index) => (
            <div key={index} className="relative w-32 h-[80px]">
              <img
                src={getImageUrl(image.fileName) || image.src} // Use apiBaseUrl if fileUrl exists
                alt={image.alt}
                className="object-cover shadow-lg w-full h-full"
                onError={(e) => {
                  e.target.src = images1[index]?.src; // Fallback to the first image if error occurs
                }}
              />
              {index === 2 && (
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white text-[12px]">
                  <FaImage size={20} />
                  <span>+3 Photos</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

    </>
  );
};

export default PhotoGallery;
